module.exports = __webpack_public_path__ + "static/img/brees-2008-slide-4.17bcc41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-slide-4.jpg
// module id = SvYj
// module chunks = 1